import { useState, useCallback } from "react";
import { toast } from "sonner";
import { logWarn } from "@/lib/log";

export function useObsChannel(obsToken) {
    const [obsCopied, setObsCopied] = useState(false);

    const obsUrl = obsToken ? `${window.location.origin}/obs?token=${obsToken}` : "";

    const copyObsLink = useCallback(() => {
        if (!obsUrl) return;
        navigator.clipboard
            .writeText(obsUrl)
            .then(() => {
                setObsCopied(true);
                toast.success("OBS link copied — add it as a Browser Source");
                setTimeout(() => setObsCopied(false), 2000);
            })
            .catch((err) => {
                logWarn("[SPCLIVE] clipboard denied", err);
                toast.error("Copy failed — please select the link and copy manually");
            });
    }, [obsUrl]);

    return { obsUrl, obsCopied, copyObsLink };
}
